import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postSignup = (d) => axios.post(`${API}/signup`, d);
export const postProductQuiz = (d) => axios.post(`${API}/product-quiz`, d);
export const postSisterQuiz = (d) => axios.post(`${API}/sister-quiz`, d);
export const postDesignLab = (d) => axios.post(`${API}/design-lab`, d);
export const postProductIdea = (d) => axios.post(`${API}/product-idea`, d);
